<template>
  <v-card>
    <v-card-title>
      Pending Invitations
      <v-spacer />
      <v-chip class="ml-2" small>
        {{ invites.length }}
      </v-chip>
    </v-card-title>

    <v-card-text v-if="invites.length === 0">
      <v-alert type="info" text>
        No pending invitations. Invite users to get started.
      </v-alert>
    </v-card-text>

    <v-list v-else two-line>
      <v-list-item v-for="invite in invites" :key="invite.id">
        <v-list-item-avatar>
          <v-icon>person</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            {{ invite.name || invite.emailAddress }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <div class="d-flex flex-column">
              <span>{{ invite.emailAddress }}</span>
              <span class="text-caption">
                Invited by
                {{
                  invite.invitedBy
                    ? invite.invitedBy.name
                    : 'Deleted user'
                }}
                on
                {{ formatDate(invite.createdAt) }}
              </span>
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn
                icon
                color="error"
                :disabled="actionInProgress"
                v-on="on"
                @click="$emit('delete', invite)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>Revoke invitation</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { UserInvite } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'UserInviteList',
  props: {
    invites: {
      type: Array,
      default: () => [],
      validator: (field) =>
        typeHelpers.isArrayOfType(field, UserInvite),
    },
    actionInProgress: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['delete'],
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-AU', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
};
</script>
